import { ConfigForm as form, marshal } from './ConfigForm'

const provider = {
  label: 'Generic webhook',
  form,
  marshal 
}

export default provider
